import React, { Fragment, useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import Select, { SingleValue } from "react-select";
import {
  IReactSelect,
  ISelectElement,
} from "../../../model/interface/keyValuePair";

const owners = [
  {
    value: 1,
    label: "James,t",
  },
  {
    value: 2,
    label: "Adam Sams",
  },
  {
    value: 3,
    label: "Adam Wills",
  },
];
const ReassginOwnerPopup: React.FC<any> = ({
  closeReassignOwnerModal,
  reassignOwner,
}: {
  closeReassignOwnerModal: () => void;
  reassignOwner: (newOwnerId) => void;
}) => {
  const [open, setOpen] = useState(true);
  const [selectedOwner, setSelectedOwner] = useState<ISelectElement>();

  const handleSelectedOwner = (option: SingleValue<IReactSelect> | null) => {
    if (option) {
      const selectElement: ISelectElement = {
        value: option.value.toString(),
        label: option.label,
      };
      setSelectedOwner(selectElement);
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={setOpen}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                <button
                  type="button"
                  className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none "
                  onClick={() => closeReassignOwnerModal()}
                >
                  <span className="sr-only">Close</span>
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div className="sm:flex sm:items-start">
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                  <DialogTitle as="h3" className="text-sm text-gray-700 pb-8">
                    Reassign Feedback
                  </DialogTitle>
                  <div className="mt-2">
                    <p className="text-sm text-gray-700">
                      Select owner to reassign this task
                    </p>
                    <p className="text-sm text-gray-500 font-semibold w-52">
                      <Select
                        placeholder={""}
                        options={owners}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          menu: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#262626"
                                : "#262626",
                            marginTop: 0,
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        isSearchable={false}
                        isClearable={true}
                        onChange={handleSelectedOwner}
                      />
                    </p>
                  </div>
                  <div className="col-span-2 sm:col-span-2 ">
                    <label className="text-sm text-gray-700">Comments</label>
                    <div className="contentArea">
                      <textarea
                        style={{
                          minHeight: "150px",
                        }}
                        id="comment"
                        name="comment"
                        autoComplete="off"
                        className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-color text-base font-medium text-white hover:bg-primary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => reassignOwner(selectedOwner?.value)}
                >
                  Reassign
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:mt-0 sm:w-auto sm:text-sm"
                  onClick={() => closeReassignOwnerModal()}
                >
                  Cancel
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ReassginOwnerPopup;
